<div class="fixed inset-x-0 bottom-0 z-[999999] transition-transform transform translate-y-full duration-300 h-screen"
  (click)="close.emit()" [ngClass]="{
    'translate-y-full': !isOpen,
    'translate-y-0': isOpen
  }" [ngStyle]="{
    paddingTop: effectivePaddingTop,
    width: width,
    borderRadius: borderRadius
  }" [ngClass]="customClass">
  <div class="bg-white rounded-3xl relative overflow-hidden h-full rounded-b-none shadow-none" [ngStyle]="{
    borderRadius: borderRadius
  }" [ngClass]="toastCustomClass" (click)="$event.stopPropagation()">
    <!-- Pastille pleine : la croix seule se perdait sur un fond clair comme
         sur le dégradé vert du paywall. La cible fait 40 px, la taille
         minimale confortable au pouce. -->
    <button type="button"
      class="absolute top-3 right-3 z-30 flex h-10 w-10 items-center justify-center rounded-full bg-grey-100/90 text-grey-700 shadow-sm active:bg-grey-200"
      [attr.aria-label]="'common.close' | translate"
      (click)="close.emit()">
      <vw-close-icon />
    </button>
    <ng-content></ng-content> <!-- This allows you to pass any content inside the bottom sheet -->
  </div>
</div>